import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import splitDux from 'src/redux/split';
import autobind from 'autobind-decorator';
import HvSvg from 'src/components/HvSvg';

import {
  SliderControlButtonsContainer,
  SliderControlBarTextBox,
  SliderDownButton,
  SliderDownIcon,
  SliderUpButton,
  SliderUpIcon,
} from './styled';

const mapStateToProps = (state) => ({
  labels: splitDux.selectors.getSplitToolLabels(state),
  oneInchPercentageIncrement: splitDux.selectors.getSplitToolOneInchPercentageIncrement(
    state,
  ),
  splitPercentage: splitDux.selectors.getSplitPercentage(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleSplitToolOffsetChange: splitDux.actions.handleSplitToolOffsetChange,
    },
    dispatch,
  );

class SliderControlButtons extends PureComponent {
  static propTypes = {
    handleSplitToolOffsetChange: PropTypes.func.isRequired,
    labels: PropTypes.object.isRequired,
    oneInchPercentageIncrement: PropTypes.number.isRequired,
    splitPercentage: PropTypes.number.isRequired,
  };

  @autobind
  handleUpButtonOnClick() {
    const {
      handleSplitToolOffsetChange,
      oneInchPercentageIncrement,
      splitPercentage,
    } = this.props;

    const newPercentage = Math.min(
      1 - oneInchPercentageIncrement,
      splitPercentage + oneInchPercentageIncrement,
    );
    handleSplitToolOffsetChange(newPercentage);
  }

  @autobind
  handleDownButtonOnClick() {
    const {
      splitPercentage,
      handleSplitToolOffsetChange,
      oneInchPercentageIncrement,
    } = this.props;

    const newPercentage = Math.max(
      0 + oneInchPercentageIncrement,
      splitPercentage - oneInchPercentageIncrement,
    );
    handleSplitToolOffsetChange(newPercentage);
  }

  render() {
    const {
      labels: { currentValueLabelType2 },
    } = this.props;
    return (
      <SliderControlButtonsContainer>
        <SliderUpButton
          data-selenium="sliderUpButton"
          onClick={this.handleUpButtonOnClick}
        >
          <SliderUpIcon size={28}>
            <HvSvg src={require('src/assets/icons/play-button.svg')} />
          </SliderUpIcon>
        </SliderUpButton>

        <SliderControlBarTextBox>
          {currentValueLabelType2}
        </SliderControlBarTextBox>

        <SliderDownButton
          data-selenium="sliderDownButton"
          onClick={this.handleDownButtonOnClick}
        >
          <SliderDownIcon size={28}>
            <HvSvg src={require('src/assets/icons/play-button.svg')} />
          </SliderDownIcon>
        </SliderDownButton>
      </SliderControlButtonsContainer>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SliderControlButtons);
